import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  Listinventaire,
  confirmerInventaireApi,
  findInventaireApi,
} from "../../_App/Redux/Slices/inventaire/inventaireSlice";
import { formadate, formatDateAndTime } from "../../_App/Helpers/helpers";
import {
  SelectedOrganisations,
  selectUserId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import InventaireDetaliTable from "./InventaireDetaliTable";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function InventaireTable({
  t,
  list_inventaires,
  list_inventaire_details,
}: any) {
    const navigate = useNavigate();
  
  const user = useAppSelector(selectUserId);
  const dispatch = useAppDispatch();
  const listdOrganisations = useAppSelector(SelectedOrganisations);
  const [showModalDetails, setshowModalDetails] = useState(false);
  const [inventaire, setinventaire] = useState(null);

 const Confirmer = async (InventaireId: string) => {
  const result = await Swal.fire({
        title: t("Êtes-vous sûr ?"),
    text: t("Vous êtes sur le point de confirmer cet inventaire."),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Confirmer!"),
        cancelButtonText: t("Cancel!"),
      })
  if (result.isConfirmed) {
    const data = { user, inventaire_id: InventaireId };
    const response = await dispatch(confirmerInventaireApi(data));

    if (response?.payload.success) {
      ToastSuccess(t(response?.payload.message));
      window.location.reload();
    } else {
      ToastWarning(t(response?.payload.message));
    }
  }
};
  const findEcart = (id: any) => {
    const find_ecart = list_inventaire_details[id]?.find(
      (i: any) => parseFloat(i.stk_before_inventaire) !== parseFloat(i.quantite)
    );
    if (find_ecart) {
      return true;
    } else {
      return false;
    }
  };


const voirEcart = (item: any) => {
  if (!item?.confirmer) {
    Swal.fire({
      icon: "warning",
      title: "Non confirmé",
      text: "Cet incident n'a pas encore été confirmé.",
    });
  } else {
    // ouvrir une nouvelle fenêtre vers la page de l'incident
    const url = `/incident/${item._id}`;
    window.open(url, "_blank"); // "_blank" ouvre dans un nouvel onglet
  }
};
  return (
    <div>
      <table className="table table-bordered mb-5">
        <thead>
          <tr>
            <th></th>
            <th colSpan={2}>{t("code inventaire")}</th>
            <th>{t('commentaire')}</th>
            <th>{t("Organisation")}</th>
            <th>{t("Depot")}</th>
            <th>{t("User")}</th>
            <th>{t("Date creation")}</th>
            <th>{t("Date modification")}</th>
          </tr>
        </thead>
        {list_inventaires.length !== 0 ? (
          <tbody>
            {list_inventaires?.map((item: any, index: number) => (
              <tr key={index}>
                {item.confirmer ? (
                  <td className="color-red">confirmé</td>
                ) : (
                  <td
                    className="c-primary pointer"
                    onClick={() => Confirmer(item._id)}
                  >
                    confirmer
                  </td>
                )}
                <td
                  onClick={() => {
                    setinventaire(item);
                    setshowModalDetails(true);
                  }}
                >
                  <p className="lien-bleu-souligne"> {item.code_inventaire} </p>
                </td>
                <td className="pointer">
                  {" "}
                  <p  style={{ color: "red" }} onClick={()=>voirEcart(item)}>
                    {findEcart(item._id) && "Ecart"}
                  </p>
                </td>
                <td>{item?.titre}</td>
                <td>
                  {listdOrganisations?.find(
                    (element) => element._id === item.organisation_id
                  )?.nom || item.organisation_id}
                </td>
                <td>{item?.depots_id?.libelle || item?.depots_id}</td>
                <td>
                  {item.user?.nom}
                  {item.user?.prenom}
                </td>
                 <td>
                  {formatDateAndTime(item?.createdAt)}
                </td>
                 <td>
                      {formatDateAndTime(item?.updatedAt)}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tr>{t("aucun inventaire")}</tr>
        )}

        <tbody></tbody>
      </table>

      <InventaireDetaliTable
        t={t}
        setShowModal={setshowModalDetails}
        ShowModal={showModalDetails}
        listInventairedetails={list_inventaire_details}
        inventaire={inventaire}
        listdOrganisations={listdOrganisations}
      />
    </div>
  );
}
